// Pure auth-form validation + user-facing messaging. No React / network / secrets.
// Shared by the client login UI and the Node test suite (CommonJS).

function validateEmail(email) {
  if (typeof email !== "string") return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

// Minimum password strength for account creation.
const MIN_PASSWORD_LENGTH = 8;
function validatePassword(pw) {
  return typeof pw === "string" && pw.length >= MIN_PASSWORD_LENGTH;
}

function passwordsMatch(a, b) {
  return typeof a === "string" && a.length > 0 && a === b;
}

// Always shown for password recovery, whether or not the email has an account,
// so we never reveal whether an email is registered.
const NEUTRAL_RESET_MESSAGE =
  "If an account exists for this email, password reset instructions have been sent.";

// Map raw Supabase auth errors to clear, non-technical messages. Never returns
// token/secret detail.
function friendlyAuthError(err) {
  const raw = (err && (err.message || err.error_description || err.error)) || "";
  const m = String(raw).toLowerCase();
  if (m.includes("invalid login") || m.includes("invalid credentials")) {
    return "The email or password is incorrect.";
  }
  if (m.includes("email not confirmed")) {
    return "Please confirm your email first — check your inbox for the confirmation link.";
  }
  if (m.includes("already registered") || m.includes("already exists") || m.includes("user already")) {
    return "That email can't be used to create a new account. Try signing in or resetting your password.";
  }
  if (m.includes("rate limit") || m.includes("too many")) {
    return "Too many attempts. Please wait a few minutes and try again.";
  }
  if (m.includes("password")) {
    return "Please choose a password with at least 8 characters.";
  }
  if (m.includes("provider is not enabled") || m.includes("unsupported provider")) {
    return "This sign-in method isn't available yet. Please use email or another option.";
  }
  return "Something went wrong. Please try again.";
}

module.exports = {
  validateEmail,
  validatePassword,
  passwordsMatch,
  MIN_PASSWORD_LENGTH,
  NEUTRAL_RESET_MESSAGE,
  friendlyAuthError,
};
